export const Images = {
  logo: require('../assets/flame.png')
};
